<template>
  <div v-if="isVisible">
    <v-text-field
      :label="schema.label || schema.title"
      :class="fieldClasses"
      :placeholder="schema.placeholder"
      :counter="schema.limit"
      :rules="rules"
      :disabled="isDisabled"
      :error-messages="errorMessages"
      :success-messages="successMessages"
      :readonly="schema.readonly"
      v-model="localValue"
      @input="handleChange"
    />
  </div>
</template>

<script>
import GenericField from './GenericField';

export default {
  name: 'TextField',
  mixins: [GenericField],
  methods: {
    handleChange(val) {
      if (!this.schema.limit || val.length < this.schema.limit) return;
      this.$nextTick(() => {
        this.localValue = val.substring(0, this.schema.limit);
      });
    },
  },
};
</script>
